import { GetSidebarItemFn } from "@/components/layout/Sidebar/sidebar.types";
import { dashboardItem, engineeringMenu } from "@/features/views/sidebar-items/sidebar-items";

const techniciansItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "technicians",
    title: "Technicians",
    icon: "lely-icon-group",
});

const performanceMenu: GetSidebarItemFn = () => ({
    _type: "menu",
    title: "Performance",
    icon: "lely-icon-graph",
    links: [
        () => ({
            _type: "link",
            route: "preventiveMaintenanceOverdue",
            title: "Preventive Maintenance Overdue",
            icon: "lely-icon-robot",
        }),
        () => ({ _type: "link", route: "averageRepairTimes", title: "Average Repair Times", icon: "lely-icon-clock" }),
        () => ({ _type: "link", route: "repeatVisitCases", title: "Repeat Visit Cases", icon: "lely-icon-ongoing" }),
        () => ({ _type: "link", route: "longRepairs", title: "Long Repairs", icon: "lely-icon-clock-interval" }),
        () => ({
            _type: "link",
            route: "repairsPerAstronaut",
            title: "Repairs per Astronaut",
            icon: "lely-icon-astronaut",
        }),
        () => ({
            _type: "link",
            route: "abnormalPreventiveMaintenanceTimes",
            title: "Abnormal Preventive Maintenance Times",
            icon: "lely-icon-diagram",
        }),
        () => ({ _type: "link", route: "manHoursHigh", title: "Man-Hours High", icon: "lely-icon-calendar" }),
        () => ({ _type: "link", route: "productiveTime", title: "Productive Time", icon: "lely-icon-chart" }),
        () => ({ _type: "link", route: "mandatoryUpdates", title: "Mandatory Updates", icon: "lely-icon-refresh" }),
    ],
});

const softwareVersionOverviewItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "softwareVersionOverview",
    title: "SW Version Overview",
    icon: "lely-icon-table",
});

const partsItem: GetSidebarItemFn = () => ({
    _type: "link",
    route: "parts",
    title: "Parts Overview",
    icon: "lely-icon-gear",
});

export const teamLeadSidebarItems: GetSidebarItemFn[] = [
    dashboardItem,
    techniciansItem,
    performanceMenu,
    softwareVersionOverviewItem,
    partsItem,
    engineeringMenu,
];
